import React from "react"
import { Bar, defaults } from "react-chartjs-2"
import chartData from "../data/capacity-development"
defaults.global.defaultFontFamily = "Prompt"
defaults.global.defaultFontSize = 13
defaults.global.maintainAspectRatio = false

export default function BarChart({ id, title, subTitle, measure }) {
  const data = chartData.find(obj => {
    return obj.id === id
  }).data

  const options = chartData.find(obj => {
    return obj.id === id
  }).options

  // Create text fallback for chart
  var barChartLabel = ""

  data.labels.forEach((label, index) => {
    data.datasets.forEach((dataset, i) => {
      barChartLabel += `${dataset.data[index].toLocaleString()} ${measure}${
        dataset.label ? " " + dataset.label : ""
      }${i < data.datasets.length - 1 ? " and " : ""}`
    })

    barChartLabel += ` in ${label}${
      index < data.labels.length - 1 ? "; " : "."
    }`
  })

  return (
    <div className="chart chart--bar">
      {title ? <h3 className="chart__title">{title}</h3> : null}
      {subTitle ? (
        title ? (
          <h4 className="chart__sub-title">{subTitle}</h4>
        ) : (
          <h3 className="chart__sub-title">{subTitle}</h3>
        )
      ) : null}
      <figure
        className={
          options.height
            ? "chart__container chart__container--" + options.height
            : "chart__container"
        }
        aria-label={barChartLabel}
      >
        <Bar data={data} options={options} />
      </figure>
    </div>
  )
}
